import React, { useState, useRef, useEffect } from "react";
import { Navigate, Link, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { alertActions } from "../_actions";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import SignatureCanvas from "react-signature-canvas";
import axios from "axios";
import { FaFileSignature } from "react-icons/fa";
import { CiText } from "react-icons/ci";
import { FaCalendarDays } from "react-icons/fa6";
import { RiDeleteBin5Fill } from "react-icons/ri";
import { Resizable } from "re-resizable";
import Draggable from "react-draggable";
import { FaCog } from "react-icons/fa";
import { FaBars } from "react-icons/fa";
import { BiExpandAlt } from "react-icons/bi";
import { PDFDocument, StandardFonts } from "pdf-lib";
import { Document, Page, pdfjs } from "react-pdf"; // Import pdf-lib to edit PDFs
import Layout from "../Dashboard/Layout";
import EsignModal from "../components/eSignModal";
import DemoGuide from "../component/modals/demoGuide";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/fr.js";
import ActionModal from "../components/ActionModal";
const EsignerDesDocuments = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [uploadError, setUploadError] = useState(null);
  const [uploadSuccess, setUploadSuccess] = useState(null);
  const [isEditing, setIsEditing] = useState(false); // State to toggle between view and edit mode
  const [signaturePreview, setSignaturePreview] = useState(null); // State to store the signature preview
  const sigPad = useRef(null);
  const dispatch = useDispatch();
  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
  const [showPopup, setShowPopup] = useState(false);
  const [activeInput, setActiveInput] = useState(null);
  const [inputs, setInputs] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [documentData, setDocumentData] = useState(null);
  const [signatureImage, setSignatureImage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [numPages, setNumPages] = useState(null);

  // const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
  // const [showPopup, setShowPopup] = useState(false);
  const [isNext, setIsNext] = useState(false);
  // const [activeInput, setActiveInput] = useState(null);
  // const [inputs, setInputs] = useState([]);
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const [isShareOpen, setIsShareOpen] = useState(false);
  const [isActionOpen, setIsActionOpen] = useState(false);
  const [isDemoOpen, setIsDemoOpen] = useState(false);
  const [docId, setDocId] = useState(null);
  const [userData, setUserData] = useState({});
  const [fileType, setFileType] = useState("");
  const { id, token } = useParams();
  console.log("NM<>MASj", id, token);
  const handleNext = () => {
    setIsNext(true);
  };
  useEffect(() => {
    fetchDossiers();
  }, [id]);
  const fetchDossiers = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}api/prouser/update-document/${id}/${token}`
      );
      // console.log("response>>??>?>?>?", response);
      if (response.status === 200 && response.data.success) {
        // Convert the Base64 string to a Blob
        setDocumentData(response.data.data);
        if(response.data.data.userData.position){
          setPopupPosition(response.data.data.userData.position);
        }
        // setUserData(response.data.data.userData);
        setInputs((prevInputs) => [...prevInputs, response.data.data.inputData]);
        const byteCharacters = atob(response.data.data.file_attachment); // Decode the Base64 string
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
          const slice = byteCharacters.slice(offset, offset + 1024);
          const byteNumbers = new Array(slice.length);

          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: "application/pdf" });
        // const fileType = response.data.data.file_detail
        //   .split(".")
        //   .pop()
        //   .toLowerCase();
        setSelectedFile(blob);
        // setFileType(fileType);
        // Create a URL for the Blob and set it to the state
        setFile(URL.createObjectURL(blob));

        setIsDemoOpen(true);
        // setSelectedFile(blob);
        // setFilePreview(response?.data?.filename);
        setFileType(
          response.data.data.original_type !== ""
            ? response.data.data.original_type
            : "pdf"
        );
        // Create a URL for the Blob and set it to the state
        // setFile(URL.createObjectURL(blob));
      }
    } catch (err) {
      console.log("Error fetching dossiers", err);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handlePdfClick = (pageIndex, e) => {
    const rect = e.target.getBoundingClientRect();
    const x = e.clientX - rect.left; // X position of click
    const y = e.clientY - rect.top; // Y position of click
    const position = {
      x: x,
      y: y,
      pageIndex: pageIndex,
    };
    // Store click position for the specific page
    // const newClickPositions = [...popupPosition];
    // newClickPositions[pageIndex] = { x, y };
    if (isEditing) {
      setPopupPosition(position);
      setShowPopup(true);
    }
  };

  const handleToolClick = (type) => {
    setShowPopup(false);
    const pos = {
      x: popupPosition.x < 139 ? popupPosition.x + 135 : popupPosition.x,
      y:
        fileType === "doc" || fileType === "docx"
          ? popupPosition.y +
            popupPosition.pageIndex * 800 -
            popupPosition.pageIndex * (popupPosition.pageIndex < 4 ? 15 : 10)
          : popupPosition.y + popupPosition.pageIndex * 870,
    };
    const newInput = {
      id: Date.now(),
      type,
      position: pos,
      y: popupPosition.y,
      x: popupPosition.x,
      content: type === "date" ? dayjs(new Date()) : "",
      size: { width: 200, height: 40 },
      pageIndex: popupPosition.pageIndex,
    };
    setInputs([...inputs, newInput]);
    setActiveInput(newInput.id);
  };

  const uploadFile = async () => {
    setUploading(true);
    setUploadError(null);
    setUploadSuccess(false);
    setUploadProgress(0);
    setTimeRemaining(null);

    try {
      const signatureBlob = await fetch(signatureImage).then((res) =>
        res.blob()
      );
      if (!selectedFile) {
        alert("Veuillez d'abord télécharger un PDF !");
        return;
      }

      const pdfDocClone = await PDFDocument.load(
        await selectedFile.arrayBuffer()
      );
      const helveticaFont = await pdfDocClone.embedFont(
        StandardFonts.Helvetica
      );

      const pages = pdfDocClone.getPages();

      // Loop through inputs to add text, date, or signature
      for (const input of inputs) {
        const { type, position, content, size, pageIndex } = input;
        const pageIdx = pageIndex || 0;
        const page = pages[pageIdx];
        const x = position.x;
        const y = page.getHeight() - input.y; // invert y

        if (type === "text" || type === "date") {
          page.drawText(
            type === "date" ? dayjs(content).format("DD/MM/YYYY") : content,
            {
              x,
              y,
              size: 14,
              font: helveticaFont,
            }
          );
        } else if (type === "signature") {
          // Capture the signature from sigPad as Data URL
          const signatureBlob = await fetch(signatureImage).then((res) =>
            res.blob()
          );
          const signatureArrayBuffer = await signatureBlob.arrayBuffer();
          const signatureImageEmbed = await pdfDocClone.embedPng(
            signatureArrayBuffer
          );

          page.drawImage(signatureImageEmbed, {
            x,
            y: y - (size?.height || 40), // adjust for image height
            width: 50,
            height: size?.height || 40,
          });
        }
      }

      const pdfBytes = await pdfDocClone.save();

      const formData = new FormData();
      // formData.append("user_id", token);
      formData.append("document_id", id);
      // formData.append("signature", signatureFile);
      if (selectedFile instanceof Blob) {
        // Create a proper PDF file from the Blob with appropriate naming
        const pdfFile = new File(
          [pdfBytes],
          pdfBytes.name || `document-${Date.now()}.pdf`,
          { type: "application/pdf" }
        );
        formData.append("pdf", pdfFile);
      } else {
        // If it's already a File or other format, append as is
        formData.append("pdf", pdfBytes);
      }
      formData.append("position", JSON.stringify(inputs));
      formData.append("fileType", fileType); // Send file type to backend

      let startTime = Date.now();
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}api/prouser/update-document`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        setUploadSuccess(response?.data?.message);
        // setFile(null);
        dispatch(alertActions.success(response?.data?.message));
        // sigPad.current.clear();
        setSignatureImage(null);
        setUploadError(null);
      } else {
        setUploadError(
          "Erreur lors du téléchargement du fichier. Veuillez réessayer."
        );
      }
    } catch (error) {
      console.error("Upload error:", error);
      setUploadError(
        "Erreur lors du téléchargement du fichier. Veuillez réessayer."
      );
    } finally {
      setUploading(false);
    }
  };
  const handleDragStop = (id, e, data) => {
    const { x, y } = data;
    setInputs(
      inputs.map((input) =>
        input.id === id ? { ...input, position: { x, y } } : input
      )
    );
  };

  const handleResize = (id, direction, ref, d) => {
    setInputs(
      inputs.map((input) =>
        input.id === id
          ? {
              ...input,
              size: {
                width: input.size.width + d.width,
                height: input.size.height + d.height,
              },
            }
          : input
      )
    );
  };

  const handleInputChange = (id, value) => {
    setInputs(
      inputs.map((input) =>
        input.id === id ? { ...input, content: value } : input
      )
    );
  };

  const handleEditPdf = async () => {
    if (!file) {
      alert("Please select a PDF file");
      return;
    }

    if (!sigPad.current || sigPad.current.isEmpty()) {
      alert("Please sign the document before editing.");
      return;
    }

    // Load the selected PDF
    const existingPdfBytes = await fetch(file).then((res) => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const page = pdfDoc.getPages()[0];

    // Get signature data as DataURL
    const signatureDataUrl = sigPad.current.toDataURL("image/png");

    if (!signatureDataUrl || signatureDataUrl === "data:,") {
      alert("Signature is empty. Please sign the document.");
      return;
    }

    // Convert the signature DataURL to a Blob
    const signatureBlob = await fetch(signatureDataUrl).then((res) =>
      res.blob()
    );
    const signatureArrayBuffer = await signatureBlob.arrayBuffer();
    const signatureUint8Array = new Uint8Array(signatureArrayBuffer);

    // Embed the PNG signature image into the PDF
    const signatureImage = await pdfDoc.embedPng(signatureUint8Array);
    setSignatureImage(signatureDataUrl);
    handleCloseModal();
  };

  return (
    <Layout>
      <div className="mb-8 col-span-12 xl:col-span-9">
        <div className="xl:max-w-[1126px] w-full h-full bg-white md:rounded-[20px]">
          <div className="mainHead min-h-[80px] sm:min-h-[120px] flex sm:flex-row flex-col sm:items-center p-3 sm:p-10 sm:justify-between">
            <h1 className="text-lg sm:text-xl md:text-lg xl:text-xl 2xl:text-xl font-extrabold text-white sm:mt-0 mt-4">
              Signer des documents
            </h1>
            <div className="flex gap-4">
              <Link to="/prouser/esign-des-documents">
                <button className="bg-primary text-white py-2 px-4 rounded">
                  Listes de documents
                </button>
              </Link>
              {/* <button
                className="bg-green-500 text-white py-2 px-4 rounded"
                onClick={toggleEditMode}
              >
                {isEditing ? "Exit Edit Mode" : "Edit PDF"}
              </button> */}
            </div>
          </div>
          <div className="p-6 flex flex-col items-center">
            {/* <div style={{ width: "75%" }} className="flex direction-row my-4">
                    <BorderLinearProgress  variant="determinate" value={75} />
                    </div> */}
            <div className="w-full max-w-4xl mx-auto">
              <div
                className="mb-8 relative  flex justify-center  flex-col"
                style={{ height: "auto" }}
              >
                <h2 className="text-2xl font-bold text-center mb-4">
                  Signer des documents
                </h2>
                <p className="text-gray-600 text-center mb-12">
                  Conservez des documents en toute sécurité et signez en ligne
                </p>
                {/* <BorderLinearProgress variant="determinate" value={50} /> */}
                {/* {uploadProgress > 0 && !file ? (
                  <div style={{ width: "75%" }} className=" mx-auto">
                    <BorderLinearProgress
                      variant="determinate"
                      value={uploadProgress}
                    />
                  </div>
                ) : null} */}
              </div>
              {/* {file && isNext && (
                <button
                  className="bg-secondary text-white px-6 py-2 mb-2 h-10 rounded hover:bg-primary flex self-end ml-auto mr-20"
                  onClick={() => setIsActionOpen(true)}
                >
                  Actions
                </button>
              )} */}
              {file && !isNext && (
                <button
                  className="items-center gap-2 bg-secondary text-white px-6 py-2 mb-2 h-10 rounded hover:bg-primary flex self-end ml-auto mr-40"
                  onClick={() => setIsActionOpen(true)}
                >
                  <FaBars />
                  Actions
                </button>
              )}
            </div>
            {(() => {
              if (file && file !== "") {
                return (
                  <div className="w-full max-w-4xl mx-auto">
                    <div className="mb-8 relative" style={{ height: "auto" }}>
                      {/* <Worker
                        workerUrl={`${process.env.PUBLIC_URL}/pdf.worker.min.js`}
                      > */}
                      <div
                        // onClick={handlePdfClick}
                        className="relative h-full"
                      >
                        {fileType === "pdf" ||
                        fileType === "doc" ||
                        fileType === "docx" ? (
                          <Document
                            file={file}
                            onLoadSuccess={({ numPages }) =>
                              setNumPages(numPages)
                            } // Set total number of pages
                            onLoadError={(error) =>
                              console.error("Error loading PDF:", error)
                            }
                          >
                            {/* Render each page dynamically */}
                            {Array.from(new Array(numPages), (el, index) => (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Page
                                  pageNumber={index + 1}
                                  width={600}
                                  height={700}
                                  className="mb-4 shadow-lg"
                                  // onClick={(e) => handlePdfClick(index, e)}
                                />
                              </div>
                            ))}
                          </Document>
                        ) : null}
                      </div>
                      {showPopup && !isNext && (
                        <div
                          className="absolute bg-[#fff] rounded-lg shadow-lg border border-gray-600 flex gap-[0.08rem] overflow-hidden"
                          style={{
                            left: `${
                              popupPosition.x < 139
                                ? popupPosition.x + 135
                                : popupPosition.x
                            }px`,
                            top: `${
                              fileType === "doc" || fileType === "docx"
                                ? popupPosition.y +
                                  popupPosition.pageIndex * 800 -
                                  popupPosition.pageIndex *
                                    (popupPosition.pageIndex < 4 ? 15 : 10)
                                : popupPosition.y +
                                  popupPosition.pageIndex * 870
                            }px`,
                            // zIndex: 1000,
                          }}
                        >
                          <button
                            onClick={() => handleToolClick("signature")}
                            className="text-white bg-[#333] hover:bg-gray-200 p-2 flex flex-col items-center"
                            title="Draw"
                          >
                            <FaFileSignature className="h-5 w-5" />
                          </button>
                          <button
                            onClick={() => handleToolClick("text")}
                            className="text-white bg-[#333] hover:bg-gray-200 p-2 flex flex-col items-center"
                            title="Text"
                          >
                            <CiText className="h-5 w-5" />
                          </button>
                          <button
                            onClick={() => handleToolClick("date")}
                            className="text-white bg-[#333] hover:bg-gray-200 p-2 flex flex-col items-center"
                            title="Calendar"
                          >
                            <FaCalendarDays className="h-5 w-5" />
                          </button>
                          <button
                            onClick={() => setShowPopup(false)}
                            className="text-white bg-[#333] hover:bg-gray-200 p-2 flex flex-col items-center"
                            title="Delete"
                          >
                            <RiDeleteBin5Fill className="h-5 w-5" />
                          </button>
                        </div>
                      )}

                      {inputs.map((input) => (
                        <Draggable
                          key={input.id}
                          defaultPosition={input.position}
                          position={null}
                          onStop={(e, data) =>
                            handleDragStop(input.id, e, data)
                          }
                          disabled={isNext}
                          handle=".drag-handle"
                          // bounds=".rpv-core__viewer"
                        >
                          <div
                            style={{
                              position: "absolute",
                              // zIndex: activeInput === input.id ? 1001 : 999,
                              transform: "translate(0, 0)",
                              top: 0,
                            }}
                            className="select-none"
                          >
                            <Resizable
                              size={{
                                width: input.size.width,
                                height: input.size.height,
                              }}
                              onResizeStop={(e, direction, ref, d) =>
                                handleResize(input.id, direction, ref, d)
                              }
                              minWidth={200}
                              minHeight={40}
                              handleStyles={{
                                bottomRight: {
                                  bottom: -4,
                                  right: -4,
                                  cursor: "se-resize",
                                },
                              }}
                              // direction={{ top: true, right: true, bottom: true, left: true }}
                              enable={isNext}
                              disabled={isNext}
                              handleComponent={{
                                bottomRight: (
                                  <div className="absolute bottom-[-8px] right-[-8px] w-4 h-4 cursor-se-resize">
                                    <BiExpandAlt className="text-gray-500" />
                                  </div>
                                ),
                              }}
                            >
                              <div
                                className={`relative border border-dashed ${
                                  activeInput === input.id
                                    ? "border-orange-400"
                                    : "border-gray-300"
                                } bg-white`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setActiveInput(input.id);
                                }}
                              >
                                {/* Toolbar */}
                                {/* {!isNext && (
                                  <div className="absolute -top-8 right-0 bg-[#333] rounded-t-lg flex items-center gap-1 px-2 py-1">
                                    <button
                                      className="text-white hover:text-gray-300 p-1"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                      }}
                                    >
                                      <FaCog className="w-4 h-4" />
                                    </button>
                                    <button
                                      className="text-white hover:text-gray-300 p-1"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setInputs(
                                          inputs.filter(
                                            (i) => i.id !== input.id
                                          )
                                        );
                                        setSignatureImage(null);
                                        setShowPopup(false);
                                        setIsNext(false);
                                        setActiveInput(null);
                                      }}
                                    >
                                      <RiDeleteBin5Fill className="w-4 h-4" />
                                    </button>
                                  </div>
                                )} */}

                                {/* Drag handle */}
                                {!isNext && (
                                  <div className="drag-handle absolute top-0 left-0 w-full h-6 cursor-move bg-transparent" />
                                )}

                                {/* Content */}
                                <div className="p-2">
                                  {input.type === "text" && (
                                    <input
                                      type="text"
                                      value={input.content}
                                      onChange={(e) =>
                                        handleInputChange(
                                          input.id,
                                          e.target.value
                                        )
                                      }
                                      className="w-full outline-none text-gray-700 placeholder-gray-400"
                                      placeholder="Enter text"
                                    />
                                  )}
                                  {input.type === "date" && (
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <DatePicker
                                        value={input.content}
                                        onChange={(e) =>
                                          handleInputChange(input.id, e)
                                        }
                                        disabled={!isNext}
                                        format="DD/MM/YYYY"
                                        // className="w-full outline-none text-gray-700"
                                        slotProps={{
                                          textField: {
                                            variant: "outlined",
                                            size: "small", // don't need this anymore so feel free to remove
                                            sx: {
                                              "> .MuiOutlinedInput-root": {
                                                height: 40, // whatever height you want here
                                                border: "none",
                                                width: "100%",
                                              },
                                              "> .MuiOutlinedInput-notchedOutline":
                                                {
                                                  border: "none",
                                                },
                                            },
                                          },
                                        }}
                                      />
                                    </LocalizationProvider>
                                  )}
                                  {input.type === "signature" &&
                                    // <div className="w-full h-full min-h-[80px] flex items-center justify-center">
                                    //   <span className="text-gray-400">
                                    //     BELAW PARTNERS
                                    //   </span>
                                    // </div>
                                    (signatureImage ? (
                                      <img
                                        src={signatureImage}
                                        alt="Signature"
                                        className="w-full h-6 outline-none text-gray-700 placeholder-gray-400"
                                      />
                                    ) : (
                                      <button
                                        type="text"
                                        value={input.content}
                                        onClick={() => {
                                          // handleInputChange(
                                          //   input.id,
                                          //   e.target.value
                                          // );
                                          setIsModalOpen(true);
                                        }}
                                        className="w-full outline-none text-gray-700 placeholder-gray-400"
                                        placeholder="Signature"
                                      >
                                        {input.content || "Signature"}
                                      </button>
                                    ))}
                                </div>
                              </div>
                            </Resizable>
                          </div>
                        </Draggable>
                      ))}
                    </div>
                    {uploadSuccess && (
                      <p className="text-[#4feb34] mt-2">{uploadSuccess}</p>
                    )}
                    {uploadError && (
                      <p className="text-[#ff4c30] mt-2">{uploadError}</p>
                    )}
                    {inputs.length > 0 && (
                      <div className="mt-4 flex gap-4 justify-end mr-[4rem]">
                        <button
                          onClick={() => {
                            setInputs([]);
                            setIsNext(false);
                            setUploadError(null);
                            setUploadSuccess(null);
                          }}
                          // className="bg-[#ff4c30] hover:bg-[#ff3c20] text-white font-medium px-6 py-3 rounded-lg"
                          className="bg-[#979797] text-white px-6 py-2 rounded hover:bg-[#979797]"
                          // onClick={() => sigPad.current.clear()}
                        >
                          Annuler
                        </button>
                        <button
                          onClick={
                            signatureImage || isNext ? uploadFile : handleNext
                          }
                          // className="bg-[#ff4c30] hover:bg-[#ff3c20] text-white font-medium px-6 py-3 rounded-lg"
                          className="bg-secondary text-white px-6 py-2 rounded hover:bg-primary"
                          // onClick={uploadFile}
                          disabled={uploading}
                        >
                          {signatureImage || isNext
                            ? uploading
                              ? "Envoi en cours..."
                              : "sauvegarder"
                            : "Étape suivante"}
                        </button>
                      </div>
                    )}
                  </div>
                );
              }
            })()}
          </div>
        </div>
      </div>
      <EsignModal isOpen={isModalOpen} onClose={handleCloseModal}>
        <div className="border-2 border-gray-300 rounded-lg p-4 mb-4">
          <p className="text-gray-600 mb-2">Signez ici:</p>
          <SignatureCanvas
            penColor="black"
            ref={sigPad}
            canvasProps={{
              className: "sigCanvas border border-gray-200",
              style: { width: "100%", height: "200px" },
            }}
          />
        </div>
        <div className="mt-4 flex gap-4 justify-end mr-[4rem]">
          <button
            className="bg-[#979797] text-white px-6 py-2 rounded hover:bg-[#979797]"
            onClick={() => sigPad.current.clear()}
          >
            Effacer la signature
          </button>
          <button
            onClick={handleEditPdf}
            className="bg-secondary text-white px-6 py-2 rounded hover:bg-primary"
            disabled={uploading}
          >
            Étape suivante
          </button>
        </div>
      </EsignModal>
      {file && file !== "" && (
        <ActionModal
          isActionOpen={isActionOpen}
          documentData={documentData}
          selectedFile={selectedFile}
          setIsActionOpen={(e) => setIsActionOpen(e)}
          setIsModalOpen={(e) => {
            setIsDemoOpen(e);
            setIsEditing(true);
          }}
          fileType={fileType}
          setIsShareOpen={(e) => setIsShareOpen(e)}
          file={file}
          docId={documentData?.id}
          currentUser={userData}
          byMail={true}
        />
      )}
      {/* <ShareDocumentModal
        isModalOpen={isShareOpen}
        setIsModalOpen={() => setIsShareOpen(false)}
        // fetchDossiers={fetchDossiers}
        shareItem={{
          id: docId,
          user_id: currentUser.data.id,
        }}
      /> */}
      <DemoGuide
        isModalOpen={isDemoOpen}
        setIsModalOpen={() => setIsDemoOpen(false)}
      />
    </Layout>
  );
};

export default EsignerDesDocuments;
